import { returnsCenterIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const UpdateReturnsCenterInputSchema_ = z.object({
  id: returnsCenterIdFormat.schema,
  name: z.string().min(1),
  street1: z.string().nullable(),
  street2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postalCode: z.string().nullable(),
  country: z.string().nullable(),
});

export const UpdateReturnsCenterInputSchema: z.ZodType<UpdateReturnsCenterInput> =
  UpdateReturnsCenterInputSchema_;
export interface UpdateReturnsCenterInput
  extends z.infer<typeof UpdateReturnsCenterInputSchema_> {}

export const updateReturnsCenter = unaryRpc({
  name: "updateReturnsCenter" as const,
  input: UpdateReturnsCenterInputSchema,
  output: z.object({ success: z.boolean() }),
});
